import * as mutationTypes from "../mutation-types";
import config from "@/config/index";

import { createI18n } from "@/i18n/index";

const i18n = createI18n();

export const state = config.locale;

export const getters = {
  locale: state => state.locale,
  currency: state => state.currency
};

export const mutations = {
  [mutationTypes.SET_LOCALE]: (state, payload) => {
    state.locale = payload !== undefined ? payload : "en";
    i18n.loadLanguageAsync(payload);
  },
  [mutationTypes.SET_CURRENCY]: (state, payload) => {
    state.currency = payload !== undefined ? payload : "eur";
    //i18n.loadCurrencyAsync(payload);
  }  
};

export const actions = {
  setLocale2: ({ commit }, payload) => {
    commit(mutationTypes.SET_LOCALE, payload);
  },
  setCurrency2: ({ commit }, payload) => {
    commit(mutationTypes.SET_CURRENCY, payload);
  }  
};

export default {
  state,
  getters,
  mutations,
  actions
};
